import { render, staticRenderFns } from "./ColdManagement.vue?vue&type=template&id=0045e805&scoped=true&"
import script from "./ColdManagement.vue?vue&type=script&lang=js&"
export * from "./ColdManagement.vue?vue&type=script&lang=js&"
import style0 from "./ColdManagement.vue?vue&type=style&index=0&id=0045e805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045e805",
  null
  
)

export default component.exports